import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    sections: [
      { h: "Éditeur du site", p: "SOLAMOVE — Marque en cours d'immatriculation. Les informations relatives à la société éditrice (dénomination, forme juridique, capital, siège social, RCS) seront complétées lors de l'ouverture officielle des ventes. Contact : solamove@outlook.fr" },
      { h: "Directrice de la publication", p: "La fondatrice de SOLAMOVE." },
      { h: "Hébergement", p: "Site hébergé sur une infrastructure cloud sécurisée. Les coordonnées complètes de l'hébergeur seront précisées au lancement." },
      { h: "Propriété intellectuelle", p: "L'ensemble des contenus du site (marque SOLAMOVE, textes, visuels, identité graphique) est protégé. Toute reproduction sans autorisation est interdite." },
      { h: "Produit en développement", p: "SOLAMOVE est actuellement en phase de développement, de prototypage et de validation. Les caractéristiques, visuels et spécifications présentés peuvent évoluer avant le lancement. La pré-réservation est gratuite, sans paiement et sans engagement ; elle ne constitue pas une commande." },
    ],
  },
  privacy: {
    title: "Politique de confidentialité",
    sections: [
      { h: "Données collectées", p: "Dans le cadre de la pré-réservation, SOLAMOVE collecte : prénom, nom, adresse email, numéro de téléphone (facultatif), pointure, préférence produit (Homme / Femme / Unisexe, facultative), date d'inscription et consentement marketing." },
      { h: "Finalité du traitement", p: "Ces données sont utilisées exclusivement pour vous informer du développement de SOLAMOVE et de l'ouverture des commandes, et — avec votre consentement — pour vous adresser des actualités de la marque." },
      { h: "Base légale", p: "Le traitement repose sur votre consentement (article 6.1.a du RGPD), matérialisé par l'acceptation de la présente politique lors de l'inscription." },
      { h: "Conservation", p: "Les données sont conservées jusqu'au lancement du produit, puis pendant la durée nécessaire à la relation commerciale, sauf demande de suppression de votre part." },
      { h: "Vos droits", p: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour exercer ces droits : solamove@outlook.fr. Vous pouvez également saisir la CNIL (cnil.fr)." },
      { h: "Sous-traitants", p: "L'envoi des emails transactionnels est assuré par un prestataire d'envoi d'emails. Aucune donnée n'est vendue ni partagée à des tiers à des fins commerciales." },
      { h: "Cookies", p: "Le site n'utilise pas de cookie publicitaire sans consentement. Des mesures d'audience (Google Analytics, Meta Pixel) pourront être activées au lancement, après information et consentement." },
    ],
  },
};

export default function Legal({ kind }) {
  const content = CONTENT[kind] || CONTENT.mentions;
  return (
    <div data-testid={`legal-${kind}`} className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 py-20">
        <Link to="/" className="inline-flex items-center gap-3 font-mono-alt text-[11px] uppercase tracking-[0.25em] text-[#736F6E] hover:text-[#0D0D0D] transition-colors">
          <ArrowLeft size={14} /> SOLAMOVE
        </Link>
        <h1 className="font-display uppercase tracking-tight text-4xl sm:text-6xl mt-12 mb-16">{content.title}</h1>
        <div className="space-y-12">
          {content.sections.map((s) => (
            <div key={s.h} className="border-t border-black/[0.08] pt-8">
              <h2 className="font-display uppercase tracking-tight text-xl mb-4">{s.h}</h2>
              <p className="text-[#6E6A66] leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
        <p className="mt-20 text-[11px] text-[#736F6E]">© 2026 SOLAMOVE — Tous droits réservés.</p>
      </div>
    </div>
  );
}
